// extracted by mini-css-extract-plugin
export default {"label-group":"label-group__4ca6d505","label":"label__4ca6d505","value":"value__4ca6d505"};